import type { FormEvent } from 'react';
import { useState } from 'react';

type LeadPayload = {
  name: string;
  email: string;
  phone?: string;
  company?: string;
  note?: string;
};

export function LeadCaptureForm({
  onSubmit,
  onClose,
}: {
  onSubmit: (payload: LeadPayload) => Promise<void>;
  onClose: () => void;
}) {
  const [form, setForm] = useState<LeadPayload>({
    name: '',
    email: '',
    phone: '',
    company: '',
    note: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitting(true);
    setError(null);

    try {
      await onSubmit(form);
      onClose();
    } catch (submissionError) {
      setError(
        submissionError instanceof Error
          ? submissionError.message
          : 'Δεν ήταν δυνατή η αποστολή των στοιχείων.',
      );
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <form className="cbm-lead-form" onSubmit={handleSubmit}>
      <div className="cbm-lead-form__header">
        <div>
          <h4>Αφήστε τα στοιχεία σας</h4>
          <p>Η ομάδα μπορεί να επικοινωνήσει μαζί σας εκτός του chat.</p>
        </div>
        <button type="button" className="cbm-icon-button" onClick={onClose}>
          ×
        </button>
      </div>

      <input
        required
        placeholder="Ονοματεπώνυμο"
        value={form.name}
        onChange={(event) => setForm((current) => ({ ...current, name: event.target.value }))}
      />
      <input
        required
        type="email"
        placeholder="Email"
        value={form.email}
        onChange={(event) => setForm((current) => ({ ...current, email: event.target.value }))}
      />
      <input
        placeholder="Τηλέφωνο"
        value={form.phone}
        onChange={(event) => setForm((current) => ({ ...current, phone: event.target.value }))}
      />
      <input
        placeholder="Εταιρεία"
        value={form.company}
        onChange={(event) => setForm((current) => ({ ...current, company: event.target.value }))}
      />
      <textarea
        placeholder="Τι θέλετε να γνωρίζει η ομάδα;"
        value={form.note}
        onChange={(event) => setForm((current) => ({ ...current, note: event.target.value }))}
      />

      {error ? <p className="cbm-error-text">{error}</p> : null}

      <div className="cbm-lead-form__actions">
        <button type="button" className="cbm-secondary-button" onClick={onClose}>
          Άκυρο
        </button>
        <button type="submit" className="cbm-primary-button" disabled={submitting}>
          {submitting ? 'Αποστολή…' : 'Αποστολή στοιχείων'}
        </button>
      </div>
    </form>
  );
}
